// extracted by mini-css-extract-plugin
export default {"inputs":"CreateStatisticForm_inputs__bEuIt","inputItem":"CreateStatisticForm_inputItem__z59OH"};